import React, { useState, useMemo } from "react";
import { Alert, Box, Button } from "@showitinc/showit-wc";

import Modal from "./base/Modal";
import NameSlugInput from "./NameSlugInput";
import ButtonBar from "./base/ButtonBar";
import DocumentStore from "../document/DocumentStore";
import { COMMANDS } from "../document/commands";
import AppConstants from "../constants/AppConstants";
import uiPrefix from "../utils/UiPrefixUtils";
import camelCaseToTitleCase from "../utils/TextTransformUtils";

const PopupRenameDesignItem = ({
  showWarning = false,
  autoFocus = true,
  name = "",
  slug = "",
  onHide,
  itemId,
  itemType,
  title,
  ...other
}) => {
  const [nameState, setNameState] = useState({ name, slug });

  const _cancel = () => {
    onHide();
  };

  const allowEmpty = title.toLowerCase() === AppConstants.ITEM_TYPE_ELEMENT;
  const formattedTitle = camelCaseToTitleCase(title);

  const invalid =
    (!nameState.slug?.length && !allowEmpty) ||
    (itemType.toLowerCase() === AppConstants.ITEM_TYPE_PAGE && nameState.slug === "index");

  const _save = () => {
    if (!invalid) {
      if (nameState.name !== name) {
        DocumentStore.dispatch({
          type: COMMANDS.UPDATE_ITEM_NAME,
          payload: { id: itemId, type: itemType, name: nameState.name },
        });
      }
      onHide();
    }
  };

  const _onNameChange = (propInfo) => {
    setNameState({ name: propInfo.value, slug: propInfo.slug });
  };

  const warningMessage = useMemo(
    () =>
      showWarning ? (
        <Box mt="2">
          <Alert variant="info" weight="bold" message="Changing name can break existing links" />
        </Box>
      ) : null,
    [showWarning]
  );

  const modalProps = { ...other, onHide, autoFocus };
  return (
    <Modal {...modalProps}>
      <Modal.Dialog size="small">
        <Modal.Dialog.Header closeButton>
          <Modal.Dialog.Title>Rename {formattedTitle}</Modal.Dialog.Title>
        </Modal.Dialog.Header>
        <Modal.Dialog.Body>
          <NameSlugInput
            propName="name"
            name={nameState.name}
            slug={nameState.slug}
            labelPrefix={formattedTitle}
            invalid={invalid}
            diffCheckEnabled={false}
            autoFocus={autoFocus}
            onSave={_save}
            allowEmpty={allowEmpty}
            onValueChange={_onNameChange}
          />
          {warningMessage}
        </Modal.Dialog.Body>
        <Modal.Dialog.Footer>
          <ButtonBar>
            <Box mr="3">
              <Button
                variant="minimal"
                data-e2e={uiPrefix("modal-cancel-btn")}
                className={uiPrefix("modal-cancel-btn")}
                onClick={_cancel}
              >
                Cancel
              </Button>
            </Box>
            <Button
              variant="feature"
              data-e2e={uiPrefix("modal-save-btn")}
              className={uiPrefix("modal-save-btn")}
              disabled={invalid}
              onClick={_save}
            >
              Save
            </Button>
          </ButtonBar>
        </Modal.Dialog.Footer>
      </Modal.Dialog>
    </Modal>
  );
};

export default PopupRenameDesignItem;
